import React, { useState } from 'react';
import MenuDrawer from './Drawer';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const drawerWidth = 240;
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: 1199,
    left: 0,
    right: 0,
    height: 80,
    '@media (max-width: 768px)': {
      height: 56,
    },
    [theme.breakpoints.up('m')]: {
      width: '100%',
    },
    backgroundColor: '#013957',
    width: '100%',
  },
  paps: {
    height: 80,
    display: 'flex',
    flexFlow: props => props.flexFlow,

    '@media (max-width: 768px)': {
      height: 56,
      minHeight: 56,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('m')]: {
      display: 'none',
    },
    backgroundColor: '#013957',
    outline: 'none',
  },
  logo: {
    width: '100%',
    display: 'flex',
    justifyContent: props => props.justifyContent,
  },
  toolbar: theme.mixins.toolbar,
  rootDrawer: {
    zIndex: '1198 !important',
  },
  drawerPaper: {
    width: drawerWidth,
    height: 'fit-content',
    backgroundColor: '#013957',
  },
}));

const HeaderClientMenu = ({ container, userdata, sections, logoPosition, hbutton}) => {
  // Nuestro
  const [isChecked, setIsChecked] = useState(true);
  
  //Logo Position by props
  const logoLeft = {
    flexFlow: 'row-reverse',
    justifyContent: 'flex-start'
  }

  const logoRight = {
    flexFlow: 'row',
    justifyContent: 'flex-end'
  }

  //Material ui
  const classes = useStyles(logoPosition === "logoRight" ? logoRight:logoLeft);
  const [left, setState] = useState(false);

  //const { container, userdata, sections } = props;
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setIsChecked(true);
    setMobileOpen(false);
  };

  const [active, setActive] = useState(false);
  const [hit, setHit] = useState(active);

  //funcion ocultar drawer
  const hideDrawer = () => {
    setIsChecked(!isChecked);
    if (!left) {
      setState(true);
      setMobileOpen(!mobileOpen);
    } else {
      setState(false);
      setMobileOpen(!mobileOpen);
    }
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.paps}>
          { hbutton && (
              <button
                className={`${
                  classes.menuButton
                } hamburger hamburger--arrow btn  ${
                  isChecked ? true : 'is-active'
                }`}
                type="button"
                onClick={() => {
                  setIsChecked(!isChecked);
                  if (!left) {
                    setState(true);
                    setMobileOpen(!mobileOpen);
                  } else {
                    setState(false);
                    setMobileOpen(!mobileOpen);
                  }
                }}
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
            )}

          <div className={classes.logo}>
            {/* <Link className="logolink" to="/">
              <img src="/img/logo/w.svg" alt="logo" />
            </Link> */}
            <a className="logolink" href="/">
              <img src="/img/logo/w.svg" alt="logo" />
            </a>
          </div>
        </Toolbar>
      </AppBar>

      <nav aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={logoPosition === 'logoRight' ? 'left' : 'right'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              root: classes.rootDrawer,
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <MenuDrawer
              hideDrawer={hideDrawer}
              userdata={userdata}
              sections={sections}
            />
          </Drawer>
        </Hidden>
      </nav>

      {/*  <Content /> */}
    </div>
  );
};

HeaderClientMenu.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  container: PropTypes.instanceOf(
    typeof Element === 'undefined' ? Object : Element
  ),
};

export default HeaderClientMenu;
